<template>
  <div class="boxshell">
    <div class="content">
    <p class="tipTopStyle">请长按保存二维码或者复制链接后使用浏览器访问，如申请链接失效，请您回到申请记录重新生成跳转链接</p>
    <div class="box">
        <div id="codeDiv" style="display: none;" ref="qrCodeUrl"></div>
      <div class="scanCodeBox">
        <div class="qrcode"  id="qrcode"></div>
      </div>
    </div>
    <p v-if="!isFromMiniProgram" class="tipTopStyle"><a :href="$route.query.url">{{ $route.query.url }}</a></p>
    <p v-else class="tipTopStyle">{{ $route.query.url }}</p>
    <!-- <p class="tipTopStyle"></p> -->
    <div
      class="handeCopy"
      :aria-label="$route.query.url"
      @click="handeCopy"
      color="#FF6538"
      type="primary"
    >复制链接</div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import Clipboard from 'clipboard';
import { Toast } from 'vant';

export default {
  data() {
    return {
      tipTop: '长按识别二维码',
      tipLow: '',
      type: '',
      picture: '',
      isFromMiniProgram: true // 添加一个标志位来表示是否从小程序进入
    };
  },
  mounted() {
    this.IsMiniProgramEnv(); // 在页面加载时检查是否从小程序进入
    this.creatQrCode(this.$route.query.url);
  },
  computed: {},
  methods: {
    // 判断是否是小程序环境
    IsMiniProgramEnv() {
      // 通过navigator.userAgent 判断
      var bl = navigator.userAgent && navigator.userAgent.indexOf('miniProgram') > -1
      this.isFromMiniProgram = bl
    },
    handeCopy() {
      const clipboard = new Clipboard('.handeCopy', {
        text(trigger) {
          return trigger.getAttribute('aria-label');
        },
      });
      clipboard.on('success', () => {
        Toast('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        // 不支持复制 console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy();
      });
    },
    creatQrCode(url) {
      const qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 180,
        height: 180,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
      const canvas = document.getElementsByTagName('canvas')[0];
      const img = this.convertCanvasToImage(canvas);
      document.getElementById('qrcode').append(img);
    },
    convertCanvasToImage(canvas) {
      // 新建Image对象
      const image = new Image();
      image.style.width = '100%';
      // canvas.toDataURL 返回的是一串Base64编码的URL
      image.src = canvas.toDataURL('image/png');
      return image;
    },
  },
};
</script>
<style scoped>
.boxshell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.content{
  max-height: 100%;
  overflow: auto;
}
.title{
  text-align: left;
  margin: 16px 40px 16px 40px;
}

.box {
  margin: 16px 60px;
  /* width: 100%; */
  background: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  border-radius: 16px;
  padding: 40px;
  box-sizing: border-box;
}
.scanCodeBox {
  width: 180px;
  height: 180px;
  margin: 0 auto;
  box-sizing: border-box;
}
.tipTopStyle {
  margin: 0 40px;
  font-size: 14px;
  color: #1c2438;
  letter-spacing: 0;
  padding: 0;
  text-align: left;
  word-break: break-all;
}
.handeCopy{
    background: #ff6538;
    display: block;
    height: 44px;
    margin: 16px 40px 0 40px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}
</style>
